import React, { FC } from 'react';
import styled from 'styled-components';
import { Selectable, SelectableProps } from '../../../common/selectable/Selectable';
import { Asset, ASSET_WIDTH, ASSET_HEIGHT } from './Asset';

export const LargeImg = styled.img`
  display: block;
  width: ${ASSET_WIDTH}px;
  height: ${ASSET_HEIGHT}px;
`;

export interface SelectableAssetProps extends SelectableProps {
  publicId: string,
  assetIndex: number,
}

export const SelectableAsset: FC<SelectableAssetProps> = ({ isSelected, onClick, publicId, assetIndex }) => (
  <Selectable isSelected={isSelected} onClick={onClick} data-test={`asset-${assetIndex}`}>
    <Asset publicId={publicId}>
      {(assetSrc: string) => <LargeImg src={assetSrc} />}
    </Asset>
  </Selectable>
);
